import { render, staticRenderFns } from "./CardApplicationsTool.vue?vue&type=template&id=45ce57b2&scoped=true&"
import script from "./CardApplicationsTool.vue?vue&type=script&lang=js&"
export * from "./CardApplicationsTool.vue?vue&type=script&lang=js&"
import style0 from "./CardApplicationsTool.vue?vue&type=style&index=0&id=45ce57b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce57b2",
  null
  
)

/* custom blocks */
import block0 from "./CardApplicationsTool.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports